<mat-accordion>
  @for (quote of quotes(); track quote.id) {
    <app-quotes-debug-tab-item [quote]="quote"></app-quotes-debug-tab-item>
  }
</mat-accordion>
